export const chargeLimitSelfPayOptions = [
  {
    title: 'Guarantee up to the full cost of treatments actually received',
    caption:
      'Authorizes charges up to the full self-pay fees for the services actually rendered — no pre-set dollar cap.',
    value: 'guarantee-full-cost',
    recommended: true
  },
  {
    title: 'Set dollar amount limit',
    caption: `Cap the maximum amount that can be auto-charged to the patient's card.`,
    value: 'set-dollar-amount',
    recommended: false
  }
];
